import { getActiveLang } from '@openclassrooms/translations';

/* @ts-ignore */
import originalGetButtonLinkProps, { Options } from './getButtonLinkProps.ts'; // keep the extension to get original file
import getWebAppRouteKey from '../getWebAppRouteKey';
import { nextJsRoutes } from '../../constants/routes';
import Link from '../../components/Link';

export default function getButtonLinkProps(path: string, options: Options) {
  const lang = getActiveLang();

  // due to the fact that this function call will always returns props to use a regular Anchor link,
  // we need to override some of them when we are in a NextJS route context
  const props = originalGetButtonLinkProps(path, options);

  /* @ts-ignore */
  const isNextJSRoute = Boolean(getWebAppRouteKey(path, nextJsRoutes));

  if (isNextJSRoute) {
    props['data-client-router'] = 'nextjs';
    props.component = Link;
  }

  // original function will return /en in all cases in this context
  // so we need to replace first segment (always the lang) by correct one
  props.href = props.href.replace(/^\/[^/]+/, `/${lang}`);

  return props;
}
